export default __webpack_public_path__ + "static/media/logo.b59b07ea.png";